import type { ReactNode } from 'react';
import { Header } from '../layout/Header';
import { Footer } from '../layout/Footer';
import { SEO } from '../layout/SEO';

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <>
      <SEO />
      <Header />
      <main className="bg-bg">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-text mb-3">{title}</h1>
          <p className="text-sm text-text-light mb-12">Last updated: {lastUpdated}</p>
          <div className="text-text-light leading-relaxed space-y-6 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-text [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:mb-4 [&_a]:text-sage-dark [&_a]:underline [&_a:hover]:text-sage [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ul]:mb-4 [&_strong]:text-text">
            {children}
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}
